// Generated by ReScript, PLEASE EDIT WITH CARE

import Dayjs from "dayjs";

function tomorrow(param) {
  return Dayjs().add(1.0, "day").toDate();
}

function today(param) {
  return Dayjs().toDate();
}

function yesterday(param) {
  return Dayjs().subtract(1.0, "day").toDate();
}

export {
  tomorrow ,
  today ,
  yesterday ,
}
/* dayjs Not a pure module */
